const DAY = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const TODAY_START_TS = new Date().setHours(0, 0, 0, 0);
const TODAY_END_TS = new Date().setHours(23, 59, 59, 999);
const ONE_DAY_TS = 24 * 60 * 60 * 1000;
const TODAY_START_TS_IN_SEC = Math.round(TODAY_START_TS / 1000);
const TODAY_END_TS_IN_SEC = Math.round(new Date().setHours(23, 59, 59) / 1000);
const TL_ROUTE_PATH = "/webapptl";
const MAPS_API_KEY = "AIzaSyDu-t6evx86x5OZEt2-ZXSVt_jFziL7wTY";

/*
  When any item added in the menu then it is necessary to add constant in this menu path file with path array.
  Array consists nm from menu object
 */
const MENUPATH = {
  DASHBOARD: ["Dashboard"],
  RIDES: ["Rides"],
  DAILY_RIDES: ["Rides", "Daily_Rides_Drives"],
  RIDE_LOG: ["Rides", "Ride_Logs"],
  STATS: ["Statistics"],
  NOTIFICATIONS: ["Notifications"],
  TRIGGERS: ["Triggers"],
  SPEED_LIMIT: ["Triggers", "Speed_Limit"],
  VIEW_SL: ["Triggers", "Speed_Limit", "View_SL"],
  ADD_SL: ["Triggers", "Speed_Limit", "Add_SL"],
  GEO_FENCE: ["Triggers", "Geo_Fence"],
  VIEW_GF: ["Triggers", "Geo_Fence", "View_GF"],
  ADD_GF: ["Triggers", "Geo_Fence", "Add_GF"],
  TRIPS: ["Trips"],
  VIEW_TRIPS: ["Trips", "View_Trips"],
  ONGOING: ["Trips", "View_Trips", "Ongoing"],
  UPCOMING: ["Trips", "View_Trips", "Upcoming"],
  COMPLETED: ["Trips", "View_Trips", "Completed"],
  NEW_TRIP: ["Trips", "New_Trip"],
  SERVICE_PANEL: ["Service_Panel"],
  SALES_PANEL: ["Sales_Panel"],
  ACCOUNT_DETAILS: ["Account_Details"],
  CURRENT_SESSIONS: ["Current_Sessions"]
}

const BOX = {
  itemStyle: {
    initialColor: "#9b9b9b",
    selectedColor: "#0094de",
  },
  iconStyle: {
    fontSize: "18px"
  },
  titleStyle: {
    fontSize: "16px"
  }
}

const DRAWER = {
  itemStyle: {
    initialColor: "#9b9b9b",
    selectedColor: "#0094de",
  },
  iconStyle: {
    fontSize: "16px"
  },
  titleStyle: {
    fontSize: "14px"
  }
}

const BOX_SUBMENU = {
  itemStyle: {
    initialColor: "#9b9b9b",
    selectedColor: "#0094de",
    marginLeft: "18%",
  },
  iconStyle: {
    fontSize: "17px"
  },
  titleStyle: {
    fontSize: "15px"
  }
}

const DRAWER_SUBMENU = {
  itemStyle: {
    initialColor: "#9b9b9b",
    selectedColor: "#0094de",
    marginLeft: "20%",
  },
  iconStyle: {
    fontSize: "16px"
  },
  titleStyle: {
    fontSize: "14px"
  }
}

const BOX_LEAFMENU = {
  itemStyle: {
    initialColor: "#9b9b9b",
    selectedColor: "#0094de",
    marginLeft: "23%",
  },
  iconStyle: {
    fontSize: "16px"
  },
  titleStyle: {
    fontSize: "14px"
  }
}

const DRAWER_LEAFMENU = {
  itemStyle: {
    initialColor: "#9b9b9b",
    selectedColor: "#0094de",
    marginLeft: "30%",
  },
  iconStyle: {
    fontSize: "14px"
  },
  titleStyle: {
    fontSize: "12px"
  }
}

function getMenu(type) {
  /*
    Object consist screens and style of menu.
    Screens is array of menu items. 'submenu' key in the any menu item specified that it has submenu.
  */
  return {
    screens: [
      { label: 'Dashboard', nm: "Dashboard", icon: 'ajjas-speedometer', link: TL_ROUTE_PATH + '/dashboard' },
      { label: 'Ride Logs', nm: "Ride_Logs", icon: 'ajjas-rides', link: TL_ROUTE_PATH + '/tlridelog' },
      // {
      //   label: 'Rides', nm: "Rides", icon: 'ajjas-rides', submenu: {
      //     screens: [
      //       { label: 'Daily Rides/Drives', nm: "Daily_Rides_Drives", link: TL_ROUTE_PATH + '/dailyStats' },
      //       { label: 'Ride Logs', nm: "Ride_Logs", link: TL_ROUTE_PATH + '/tlridelog' }
      //     ],
      //     style: type === "box" ? BOX_SUBMENU : DRAWER_SUBMENU
      //   }
      // },
      { label: 'Statistics', nm: "Statistics", icon: 'ajjas-stats', link: TL_ROUTE_PATH + '/allvehstat' },
      { label: 'Notifications', nm: "Notifications", icon: 'ajjas-bell', link: TL_ROUTE_PATH + '/notifs' },
      {
        label: 'Triggers', nm: "Triggers", icon: 'ajjas-info', submenu: {
          screens: [
            {
              label: 'Speed Limit', nm: "Speed_Limit", submenu: {
                screens: [
                  { label: 'View Speed Alerts', nm: "View_SL", link: TL_ROUTE_PATH + '/sl/view' },
                  { label: '+ Add Speed Limit', nm: "Add_SL", link: TL_ROUTE_PATH + '/sl/add' }
                ],
                style: type === "box" ? BOX_LEAFMENU : DRAWER_LEAFMENU
              }
            },
            {
              label: 'Geo-fence', nm: "Geo_Fence", submenu: {
                screens: [
                  { label: 'View Geo-fences', nm: "View_GF", link: TL_ROUTE_PATH + '/gf/view' },
                  { label: '+ Add Geo-fence', nm: "Add_GF", link: TL_ROUTE_PATH + '/gf/add' }
                ],
                style: type === "box" ? BOX_LEAFMENU : DRAWER_LEAFMENU
              }
            }
          ],
          style: type === "box" ? BOX_SUBMENU : DRAWER_SUBMENU
        }
      },
      // {
      //   label: 'Trips', nm: "Trips", icon: 'ajjas-order', submenu: {
      //     screens: [
      //       {
      //         label: 'View Trips', nm: "View_Trips", submenu: {
      //           screens: [
      //             { label: 'Ongoing', nm: "Ongoing", link: TL_ROUTE_PATH + '/sp/ongoing' },
      //             { label: 'Upcoming', nm: "Upcoming", link: TL_ROUTE_PATH + '/sp/upcoming' },
      //             { label: 'Completed', nm: "Completed", link: TL_ROUTE_PATH + '/sp/completed' }
      //           ],
      //           style: type === "box" ? BOX_LEAFMENU : DRAWER_LEAFMENU
      //         }
      //       },
      //       { label: '+ New trip', nm: "New_Trip", link: TL_ROUTE_PATH + '/sp/add' }
      //     ],
      //     style: type === "box" ? BOX_SUBMENU : DRAWER_SUBMENU
      //   }
      // },
    ],
    style: type === "box" ? BOX : DRAWER
  }
}

const DEALER_MENU = {
  screens: [
    { label: 'Service Panel', nm: "Service_Panel", icon: 'glyphicon glyphicon-wrench', link: TL_ROUTE_PATH + '/servicePanel' },
    { label: 'Sales Panel', nm: "Sales_Panel", icon: 'glyphicon glyphicon-usd', link: TL_ROUTE_PATH + '/salesPanel' },
  ]
}

const PROFILE_MENU = {
  screens: [
    { label: 'Account Details', nm: "Account_Details", icon: 'ajjas-plan', link: TL_ROUTE_PATH + '/accountdetails' },
    { label: 'App Sessions', nm: "Current_Sessions", icon: 'ajjas-session', link: TL_ROUTE_PATH + '/sessions' },
    { label: 'Signout', nm: "Signout", icon: 'ajjas-logout', link: TL_ROUTE_PATH  },
  ]
}

const SRVC_TYPES = [
  { idx: 1, nm: 'First Service' },
  { idx: 2, nm: 'Second Service' },
  { idx: 3, nm: 'Third Service' },
  { idx: 4, nm: 'Fourth Service' },
  { idx: 5, nm: 'Paid Service' },
  { idx: 6, nm: 'Other' }
];

const CALL_STAT = [
  { idx: 1, nm: 'Connected' },
  { idx: 2, nm: 'Not Connected' },
  { idx: 3, nm: 'Wrong Number' },
  { idx: 4, nm: 'Busy' },
  { idx: 5, nm: 'Ringing' }
];

const NOTIFICATION_TYPE = [
  {
    nm: "Motion sensed", t: 1, dotStyle: "timeline-item-orange", "en": [
      "Hey, Are you there? Someone moved me."
    ]
  },
  {
    nm: "Ignition off", t: 2, dotStyle: "timeline-item-yellow", "en": [
      "Hey, Thanks for letting me rest. Sigh..."
    ]
  },
  {
    nm: "Ignition on", t: 3, dotStyle: "timeline-item-yellow", "en": [
      "Yohoo, I am ready to roll out."
    ]
  },
  {
    nm: "Accident detected", t: 4, dotStyle: "timeline-item-red", "en": [
      "Come quick!",
      "experienced an accident! Click here to check my location."
    ]
  },
  {
    nm: "Stationary fall detected", t: 5, dotStyle: "timeline-item-red", "en": [
      "I just experienced a fall. Click here to check my location."
    ]
  },
  {
    nm: "Power supply off", t: 6, dotStyle: "timeline-item-green", "en": [
      "Have you removed the battery? No power available."
    ]
  },
  {
    nm: "Vehicle switched off", t: 7, dotStyle: "timeline-item-yellow", "en": [
      "Relax! The vehicle is turned off."
    ]
  },
  {
    nm: "Vehicle switched on", t: 8, dotStyle: "timeline-item-yellow", "en": [
      "Turning on, Now you can start the vehicle."
    ]
  },
  {
    nm: "Power supply on", t: 9, dotStyle: "timeline-item-green", "en": [
      "I have started receiving power from the battery."
    ]
  },
  {
    nm: "Vibration sensed", t: 14, dotStyle: "timeline-item-orange", "en": [
      "Hi, Are you there? Somebody pushed me."
    ]
  },
  {
    nm: "Vehicle reachable", t: 103, dotStyle: "timeline-item-yellow", "en": [
      "Vehicle number",
      "is now reachable."
    ]
  },
  {
    nm: "Speed alert", dotStyle: "timeline-item-blue", t: 201, "en": [
      "Speed Warning! You are driving above",
      "km/hr. Please slow down."
    ]
  },
  {
    nm: "Geo-fence alert", dotStyle: "timeline-item-blue", t: 202, "en": [
      "",
      "geofence. Check if that's okay with you."
    ]
  },
  {
    nm: "Safe-parking alert", dotStyle: "timeline-item-blue", t: 204, "en": [""]
  },
  {
    nm: "Sudden Braking", dotStyle: "timeline-item-blue", t: 251, "en": [""]
  },
  {
    nm: "Harsh acceleration", dotStyle: "timeline-item-blue", t: 252, "en": [""]
  },
  {
    nm: "Sharp Turn", dotStyle: "timeline-item-blue", t: 253, "en": [""]
  },
  {
    nm: "Over Speed", dotStyle: "timeline-item-blue", t: 254, "en": [""]
  },
];

const STATS_LIST = [
  { name: "Distance", icon: 'distance-1', id: 'dst', unit: 'KM' },
  { name: "Duration", icon: 'stopwatch', id: 'dur', unit: '' },
  { name: "Top speed", icon: 'topspeed', id: 'tps', unit: 'Km/h' },
  { name: "AVG speed", icon: 'avgspeed', id: 'avs', unit: 'Km/h' },
  { name: "AVG distance per ride", icon: 'avgdis', id: 'avd', unit: 'Km/h' },
  // {name: "Fuel Mileage", icon: 'petrol-pump', id: 'mlg',unit: 'Km/L'},
  // {name: "Fuel spending", icon: 'oil',id: 'fcost',unit: ''},
  { name: "Max lean angle", icon: 'leanangle', id: 'mang', unit: '' },
];

const DASHBOARD_GREEN = [
  // { id: 1, nm: "View all"},
  { id: 1, nm: "OnRoute" },
  // { id: 3, nm: "At Start Location"},
  { id: 2, nm: "Reached destination" }
]

const DASHBOARD_RED = [
  { id: 1, nm: "Speed alert" },
  { id: 2, nm: "GPS Lost" },
  { id: 3, nm: "Exceeded estimated time" },
  { id: 4, nm: "Exceeded estimated distance" },
  { id: 5, nm: "Not moved for 6 hours" }
]

const MAP_FILTERS = [
  { id: 1, options: DASHBOARD_GREEN, onHover: "Vehicle in a trip", bgcolor: "#6ac803", Menuid: "green", style: "-114px" },
  // { id: 2, options: DASHBOARD_RED, onHover: "View alerts", bgcolor: "#f3001d", Menuid : "red", style: "-208px" },
];

const VEH_SHIP_STATS = { // status of an individual vehicle in a shipment
  AT_SRC_START: 1,
  ENROUTE_DEST: 2,
  AT_DEST: 3,
  ENROUTE_SRC: 4,
  AT_SRC_END: 5,
  ABORTED: 6,
  GPS_LOST: -1
};

const ARROW = {
  path: "M32 16C32 24.83594 24.83594 32 16 32C7.164062 32 0 24.83594 0 16C0 7.164062 7.164062 0 16 0C24.83594 0 32 7.164062 32 16ZM16.08984 18.41797L21.91016 23.20703L16.08984 5.753906L10.27344 23.20703Z",
  fillOpacity: 1,
  anchor: { x: 12, y: 12 },
  strokeColor: "#FFFFFF",
  strokeWeight: 2,
  scaledSize: { height: 32, width: 32 },
}

var ICON = { anchor: { x: 20, y: 20 } }
const NOTIF_CNT = 50;

const NOTIF_TYPE = {
  MOTION: 1,
  IGNITION_OFF: 2,
  IGNITION_ON: 3,
  FALL_IG_ON: 4,
  FALL_IG_OFF: 5,
  POWER_OFF: 6,
  RELAY_OFF: 7,
  RELAY_ON: 8,
  POWER_ON: 9,
  VIBRATION: 14,
  DEV_NO_NETWORK: 100,
  VEH_REACHABLE: 103,
  SPEED_ALERT: 201,
  GEO_FENCE: 202,
  PSEUDO_EVT: 1001
};

const MOTION_GEN_TIME_THRESH = 20; //seconds
const MOTION_GEN_SPEED_THRESH = 5;
const VIBRATION_GEN_TIME_THRESH = 10; //seconds
const MOTION_SPEED_THRESH = 5;

const NOTIF_TYPES_ARRAY = [
  NOTIF_TYPE.MOTION,
  NOTIF_TYPE.IGNITION_OFF,
  NOTIF_TYPE.IGNITION_ON,
  NOTIF_TYPE.FALL_IG_ON,
  NOTIF_TYPE.FALL_IG_OFF,
  NOTIF_TYPE.POWER_OFF,
  NOTIF_TYPE.RELAY_OFF,
  NOTIF_TYPE.RELAY_ON,
  NOTIF_TYPE.POWER_ON,
  NOTIF_TYPE.VIBRATION,
  NOTIF_TYPE.DEV_NO_NETWORK,
  NOTIF_TYPE.VEH_REACHABLE,
  NOTIF_TYPE.PSEUDO_EVT,
  NOTIF_TYPE.SPEED_ALERT,
  NOTIF_TYPE.GEO_FENCE
];

/*
 *  ** Only in the matrix for correct mapping. No utilisation.
 * Rows correspond to columns with same index
 * */
const EVENT_CHECK_MATRIX = [  // sequence is depends on the NOTIF_TYPES_ARRAY.
  //MTN   IGN_OFF  IGN_ON  FALL_IG_ON  FALL_IG_OFF  POW_OFF  RLY_OFF  RLY_ON   POW_ON   VIB    DEV_NO_NET  VEH_REACH  PSD_EVT  SPEED_ALERT GEO_FENCE
  [true,   false,   true,    false,      true,       true,    true,    true,    true,   true,   false,      true,      true,    true,       true],  //  MOTION          0
  [true,   false,   true,    false,      true,       true,    true,    true,    true,   true,   false,      true,      true,    true,       true],  //  IGNITION_OFF    1
  [false,  true,    false,   true,       false,      true,    true,    true,    true,   false,  true,       true,      true,    true,       true],  //  IGNITION_ON     2
  [false,  true,    false,   true,       false,      true,    true,    true,    true,   false,  true,       true,      true,    true,       true],  //  FALL_IG_ON      3
  [true,   false,   true,    false,      true,       true,    true,    true,    true,   true,   false,      true,      true,    true,       true],  //  FALL_IG_OFF     4
  [true,   true,    true,    true,       true,       false,   true,    true,    true,   true,   true,       true,      true,    true,       true],  //  POWER_OFF       5
  [true,   true,    true,    true,       true,       true,    false,   true,    true,   true,   true,       true,      true,    true,       true],  //  RELAY_OFF       6
  [true,   true,    true,    true,       true,       true,    true,    false,   true,   true,   true,       true,      true,    true,       true],  //  RELAY_ON        7
  [true,   true,    true,    true,       true,       true,    true,    true,    false,  true,   true,       true,      true,    true,       true],  //  POWER_ON        8
  [true,   false,   true,    false,      true,       true,    true,    true,    true,   true,   false,      true,      true,    true,       true],  //  VIBRATION       9
  [false,  true,    false,   true,       false,      true,    true,    true,    true,   false,  false,      true,      true,    true,       true],  //  DEV_NO_NETWORK  10
  [false,  true,    false,   true,       false,      true,    true,    true,    true,   false,  true,       false,     true,    true,       true],  //  VEH_REACHABLE   11
  [true,   true,    true,    true,       true,       true,    true,    true,    true,   true,   true,       true,      true,    true,       true],  //  PSEUDO_EVT      12 **
  [false,  true,    false,   true,       true,       true,    true,    true,    true,   true,   true,       true,      true,    true,       true],  //  SPEED_ALERT     13
  [true,   true,    true,    true,       true,       true,    true,    true,    true,   true,   true,       true,      true,    true,       true],  //  GEO_FENCE     14
];

const TS_60_DAYS_OLD_FROM_NOW = new Date().setHours(0, 0, 0, 0) - 5184000000; //ms

const HARDWARE_TYPES = {
  AJJAS_WIRED: 1,
  WIRELESS: 2,
  AJJAS_LITE: 3,
}

const LITE_DRIVING_ALARMS = {
  HARSH_ACCEL: 41,
  SUDDEN_BRAKE: 48,
  SHARP_TURN: 76,
};

const MOBILE_OS = {
  ANDROID: "Android",
  IOS: "iOS",
};

const AJJAS_APP_LINKS = {
  ANDROID: "https://play.google.com/store/apps/details?id=com.ajjas",
  IOS: "https://apps.apple.com/in/app/ajjas/id1383420207",
}

module.exports = {
  DAY,
  TODAY_START_TS,
  TODAY_END_TS,
  TODAY_START_TS_IN_SEC,
  TODAY_END_TS_IN_SEC,
  DEALER_MENU,
  SRVC_TYPES,
  CALL_STAT,
  NOTIFICATION_TYPE,
  STATS_LIST,
  DASHBOARD_GREEN,
  DASHBOARD_RED,
  MAP_FILTERS,
  VEH_SHIP_STATS,
  ARROW,
  ICON,
  ONE_DAY_TS,
  MENUPATH,
  PROFILE_MENU,
  getMenu,
  NOTIF_CNT,
  NOTIF_TYPE,
  MOTION_GEN_TIME_THRESH,
  MOTION_GEN_SPEED_THRESH,
  VIBRATION_GEN_TIME_THRESH,
  NOTIF_TYPES_ARRAY,
  EVENT_CHECK_MATRIX,
  TS_60_DAYS_OLD_FROM_NOW,
  MOTION_SPEED_THRESH,
  TL_ROUTE_PATH,
  HARDWARE_TYPES,
  MAPS_API_KEY,
  LITE_DRIVING_ALARMS,
  MOBILE_OS,
  AJJAS_APP_LINKS,
};
